import React, { useState, useEffect, useRef } from "react";
import Swal from "sweetalert2";
import BASE_URL from "components/BaseUrl/apiConfig";
import Navbar from "components/Navbars/AuthNavbar";
import Footer from "components/Footers/Footer";
import DatePicker from "react-datepicker";
import { AddPayment } from "./CommonModel";
import BlockUiOverlay from "components/Expense/BlockUiOverlay";
import { useHistory } from "react-router-dom/cjs/react-router-dom";
import { DateRangePicker } from "rsuite";
import "rsuite/dist/rsuite.min.css";

const Quantitytracking = () => {
  const [formData, setFormData] = useState({
    date: "",
    Item: "",
    quantity: "",
    description: "",
  });
  const history = useHistory();
  const [loading, setLoading] = useState(false);
  const [items, setItems] = useState([]);
  const [editing, setEditing] = useState(false);
  const [isOpen, setIsOpen] = useState(false);
  const [fetchQuantityId, setQuantityId] = useState();
  const [selectItem, setSelectedItem] = useState({
    totalPrice: 0,
    itemName: "",
    itemID: 0,
  });
  const [itemDescription, setItemDescripion] = useState();
  const [pandingPayment, setPandingPayment] = useState();
  const [tabdata, setTabData] = useState([]);
  const [activeTab, setActiveTab] = useState(0);
  const [selectDate, setSelectedDate] = useState(new Date());
  const [quantitys, setQuantity] = useState([]);
  const currentDate = new Date();
  const [currency, setCurrency] = useState("");
  const totalPrice = quantitys.length > 0 ? quantitys[0].totalPrice : 0;
  const itemName = quantitys.length > 0 ? quantitys[0].itemName : 0;
  const itemID = quantitys.length > 0 ? quantitys[0].itemID : 0;
  const totalQuantity = quantitys.length > 0 ? quantitys[0].totalQuantity : 0;
  const [startDate, setStartDate] = useState(null);
  const [endDate, setEndDate] = useState(null);
  const storedUserData = localStorage.getItem("userData");
  let userId = "";
  let userTypeId = "";
  let groupId = "";
  if (storedUserData) {
    const userData = JSON.parse(storedUserData);
    userId = userData.userId;
    userTypeId = userData.userTypeId;
    groupId = userData.groupId;
  }
  const [successFlag, setSuccessFlag] = useState(false);
  const [selectedYear, setSelectedYear] = useState(
    new Date().getFullYear().toString()
  );
  const [selectedMonth, setSelectedMonth] = useState(
    (new Date().getMonth() + 1).toString()
  );
  const [button, setButton] = useState(null);

  const fetchQuantity = async (itemId, year, month, startDate, endDate) => {
    setLoading(true);
    setQuantityId(itemId);
    try {
      // Convert start date and end date to ISO 8601 format strings and encode them
      const encodedStartDate = startDate
        ? encodeURIComponent(startDate.toISOString().split("T")[0])
        : "";
      const encodedEndDate = endDate
        ? encodeURIComponent(endDate.toISOString().split("T")[0])
        : "";

      // Ek saath dono API endpoints ko call karen
      const [quantityResponse, paymentResponse] = await Promise.all([
        fetch(
          `${BASE_URL}/api/QuantityTracking/GetAllItemQuantity?userId=${userId}&itemId=${itemId}&month=${month}&year=${year}&startDate=${encodedStartDate}&endDate=${encodedEndDate}`
        ),
        fetch(
          `${BASE_URL}/api/QuantityTracking/GetPaymentofItem?UserId=${userId}&ItemId=${itemId}`
        ),
      ]);

      // Quantity data aur payment data ko JSON mein parse karen
      const quantityData = await quantityResponse.json();
      const paymentData = await paymentResponse.json();
      // console.log(quantityData);
      // Quantity aur payment data ko apne alag state variables mein set karen
      setQuantity(quantityData);
      //fetchData();
      setPandingPayment(paymentData);
      setLoading(false);
    } catch (error) {
      setLoading(false);
      console.error("Error fetching data:", error);
    }
  };

  //here is the function of the get Items
  const fetchItems = async () => {
    setLoading(true);
    fetch(`${BASE_URL}/api/Item/GetAllItems?UserId=${userId}`)
      .then((response) => response.json())
      .then((data) => {
        setItems(data);
        // fetchData();
        setLoading(false);
      })
      .catch((error) => {
        console.error("Error fetching items:", error);
        setLoading(false);
      });
  };

  //here is the code of fetch item function
  useEffect(() => {
    fetchItems();
  }, []);

  useEffect(() => {
    // Fetch data for initially active tab when the component mounts
    if (items.length > 0) {
      setTabData(items[activeTab]);
      fetchQuantity(
        items[activeTab].itemID,
        selectedYear,
        selectedMonth,
        startDate,
        endDate
      );
      setItemDescripion(items[activeTab].defaultText);
    }
  }, [items, selectedYear, selectedMonth, activeTab, successFlag]); // Fetch items when component mounts or active tab changes

  //here is the code of the get Year and Months
  // const fetchData = async () => {
  //     try {
  //         const response = await fetch(`${BASE_URL}/api/Item/GetItemYearAndMonth?userId=${userId}`);
  //         const data = await response.json();
  //         const yearsArray = [...new Set(data.map(item => item.year))];
  //         const monthsArray = data.map(item => item.month);
  //         setYears(yearsArray);
  //         setMonths(monthsArray);
  //     } catch (error) {
  //         console.error('Error fetching data:', error);
  //     }
  // };

  // useEffect(() => {
  //     fetchData();
  // }, []); // Empty dependency array to ensure useEffect runs only once

  //here is the code of get currency
  useEffect(() => {
    const fetchCurrencyData = async () => {
      try {
        const response = await fetch(
          `${BASE_URL}/api/Users/GetCurrencyByUserId?groupId=${groupId}`
        );
        const data = await response.json();
        // Assuming the API response has a property called 'currency'
        setCurrency(data.currency);
      } catch (error) {
        console.error("Error fetching currency data:", error);
      } finally {
      }
    };

    fetchCurrencyData();
  }, []);

  const openModal = () => {
    setIsOpen(true);
    setSelectedItem({
      totalPrice: totalPrice,
      itemName: itemName,
      itemID: itemID,
    });
  };

  const closeModal = () => {
    setIsOpen(false);
  };

  // Tab click handler
  const handleTabClick = (index) => {
    setActiveTab(index);
    setTabData(items[index]); // Update tab data
    fetchQuantity(items[index].itemID, selectedYear, selectedMonth); // Fetch quantity data for the clicked tab
    //here is the code of the get item description
    setItemDescripion(items[index].defaultText);
    setButton(null);
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prevData) => ({
      ...prevData,
      [name]: value,
    }));
  };

  const handleDescriptionChange = (e) => {
    const { value } = e.target;
    setItemDescripion(value); // Update itemDescription state with the typed value
  };

  // Function to set form data for editing
  const handleEditClick = (quantity) => {
    if (userId == quantity.userId) {
      setSelectedDate(quantity.date);
      setItemDescripion(quantity.quantityDescription);
      setFormData({
        quantityTrackingID: quantity.quantityTrackingID,
        date: quantity.date,
        Item: quantity.itemID,
        quantity: quantity.quantity,
        // description: quantity.quantityDescription
      });
      setEditing(true); // Set editing state to true
    } else if (userTypeId == 2) {
      // Changed to else if
      setSelectedDate(quantity.date);
      setItemDescripion(quantity.quantityDescription);
      setFormData({
        quantityTrackingID: quantity.quantityTrackingID,
        date: quantity.date,
        Item: quantity.itemID,
        quantity: quantity.quantity,
        // description: quantity.quantityDescription
      });
      setEditing(true); // Set editing state to true
    } else {
      Swal.fire("Sorry!", "You can not update this Quantity.", "error"); // Changed 'Error' to 'error'
    }
  };

  const quantityInputRef = useRef(null);
  //Submit Quantity button
  const handleSubmit = async (e) => {
    e.preventDefault();

    // Validate required fields
    if (!selectDate || !formData.quantity) {
      // Swal.fire({
      //     icon: 'error',
      //     title: 'Something went wrong. ',
      //     text: 'All fields are required!',
      // });
      // Set focus to the quantity input field
      quantityInputRef.current.focus();
      return;
    }

    try {
      setLoading(true);
      let response;
      // Remove the references to 'item' in the conditional statements
      if (formData.Item) {
        response = await fetch(
          `${BASE_URL}/api/QuantityTracking/UpdateQuantity`,
          {
            method: "POST",
            headers: {
              "Content-Type": "application/json",
            },
            body: JSON.stringify({
              quantityTrackingID: formData.quantityTrackingID,
              itemID: formData.Item,
              date: selectDate,
              quantity: formData.quantity,
              quantityDescription: itemDescription,
            }),
          }
        );
      } else {
        response = await fetch(
          `${BASE_URL}/api/QuantityTracking/InsertQuantity`,
          {
            method: "POST",
            headers: {
              "Content-Type": "application/json",
            },
            body: JSON.stringify({
              itemID: tabdata.itemID,
              userId: userId,
              date: selectDate,
              quantity: formData.quantity,
              quantityDescription: itemDescription,
            }),
          }
        );
      }

      if (response.ok) {
        console.log(
          formData.Item
            ? "Item Quantity updated successfully!"
            : "Item Quantity added successfully!"
        );
        setSelectedDate(new Date());
        if (!formData.Item) {
          //Month ko get karna
          const month = selectDate.getMonth() + 1;
          const year = selectDate.getFullYear();
          setSelectedYear(year);
          setSelectedMonth(month);
        }

        setFormData({
          date: "",
          Item: "",
          quantity: "",
          description: "",
        });
        setEditing(false);
        setSuccessFlag((prev) => !prev);
        // Display SweetAlert
        Swal.fire({
          icon: "success",
          title: "Success",
          text: formData.Item
            ? "Item Quantity updated successfully!"
            : "Item Quantity added successfully!",
        });
        setLoading(false);
      } else {
        const errorMessage = await response.text();
        Swal.fire({
          icon: "error",
          title: "Error",
          text: errorMessage,
        });

        setLoading(false);
      }
    } catch (error) {
      setLoading(false);
      Swal.fire({
        icon: "error",
        title: "Error",
        text: error,
      });
    }
  };

  //Delete Quantity Tracking
  const deleteQuantity = async (quantityTrackingID) => {
    // Show a SweetAlert confirmation before deleting
    Swal.fire({
      title: "Confirmation",
      text: `Are you sure want to delete?`,
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#d33",
      cancelButtonColor: "#3085d6",
      confirmButtonText: "Yes",
    }).then(async (result) => {
      // Marking this as async
      if (result.isConfirmed) {
        try {
          const response = await fetch(
            `${BASE_URL}/api/QuantityTracking/DeleteQuantity?quantityTrackingId=${quantityTrackingID}&userId=${userId}&userTypeId=${userTypeId}`,
            {
              method: "POST",
              headers: {
                "Content-Type": "application/json",
              },
            }
          );
          if (!response.ok) {
            const errorMessage = await response.text();
            throw new Error(
              `HTTP error! Status: ${response.status}, Message: ${errorMessage}`
            );
          }
          fetchQuantity(
            fetchQuantityId,
            selectedYear,
            selectedMonth,
            startDate,
            endDate
          );
          Swal.fire(
            "Deleted!",
            "Quantity has been deleted successfully.",
            "success"
          );
        } catch (error) {
          console.error("Error deleting expense:", error);
          // Check if the error message indicates "You can not update this data"
          if (error.message.includes("You can not Delete this transaction")) {
            // Display a user-friendly error message
            Swal.fire({
              icon: "error",
              title: "Sorry!",
              text: "You can not Delete this Quantity.",
            });
          } else {
            // Display a generic error message
            Swal.fire({
              icon: "error",
              title: "Error",
              text: "An error occurred while fetching the edit expense data. Please try again later.",
            });
          }
        }
      }
    });
  };

  // Function to navigate to the "Add Expense Type" page
  const NavigateAddItemPage = () => {
    history.push("/addItem");
  };

  // const getMonthName = (monthNumber) => {
  //     const months = [
  //         "January", "February", "March", "April", "May", "June",
  //         "July", "August", "September", "October", "November", "December"
  //     ];
  //     return months[parseInt(monthNumber, 10) - 1];
  // };

  const GETAllQuantityData = () => {
    if (button != null) {
      fetchQuantity(
        fetchQuantityId,
        selectedYear,
        selectedMonth,
        startDate,
        endDate
      );
      setButton(null);
    } else {
      fetchQuantity(fetchQuantityId, 0, 0, null, null);
      setButton(1);
    }
  };

  function formatDateToDDMMYYYY(dateString) {
    const date = new Date(dateString);
    const formattedDate = date.toLocaleDateString("en-GB", {
      day: "2-digit",
      month: "2-digit",
      year: "numeric",
    });
    return formattedDate;
  }

  return (
    <>
      <Navbar />
      <div className="cust-div" style={{ minHeight: "550px" }}>
        <BlockUiOverlay visible={loading} />
        <div className="container mx-auto p-4">
          <div className="flex justify-between mb-1 items-center flex-wrap">
            <h1 className="text-2xl  font-bold">Manage Your Item Quantity</h1>

            {userTypeId === 2 && (
              <h1 className="text-xl  ">
                Pending Amount({currency})
                <button
                  onClick={() => openModal()}
                  className=" text-white active:bg-lightBlue-600 text-xs font-bold uppercase ml-3 px-4 py-1 rounded shadow hover:shadow-lg outline-none focus:outline-none ease-linear transition-all duration-150"
                  type="button"
                  style={{ background: "orange" }}
                  disabled={pandingPayment === 0}
                >
                  <span className="capitalize">Pay :</span> {pandingPayment}
                </button>
              </h1>
            )}
          </div>

          {items && items.length > 0 ? (
            <>
              <div className="flex justify-between items-center flex-wrap">
                {button ? (
                  <strong className="text-lg md:text-sm text-bold"></strong>
                ) : startDate ? (
                  <strong className="text-lg md:text-sm text-bold">
                    From {formatDateToDDMMYYYY(startDate)} to{" "}
                    {formatDateToDDMMYYYY(endDate)}
                  </strong>
                ) : (
                  <strong className="text-lg md:text-sm text-bold">
                    {new Date(
                      selectedYear,
                      selectedMonth - 1
                    ).toLocaleDateString("en-US", { month: "long" })}{" "}
                    {selectedYear}
                  </strong>
                )}

                <div className="flex justify-between items-center flex-wrap">
                  <div>
                    <button
                      className=" text-white text-xs font-medium bg-lightBlue-500  px-4 py-1 mr-2  rounded shadow hover:shadow-lg outline-none focus:outline-none ease-linear transition-all duration-150 "
                      type="submit"
                      title="Disply All Quantity"
                      onClick={() => GETAllQuantityData()}
                    >
                      {button ? "Cancel" : "All"}
                    </button>
                  </div>

                  <strong
                    className="text-lg md:text-sm text-bold mr-3"
                    style={{ color: "darkgray" }}
                  >
                    or
                  </strong>

                  <DateRangePicker
                    size="md"
                    format="dd/MM/yy"
                    character=" – "
                    placeholder="Select Date Range"
                    showOneCalendar
                    onChange={(value) => {
                      if (value === null) {
                        setStartDate(null);
                        setEndDate(null);
                        setSelectedYear(new Date().getFullYear().toString());
                        setSelectedMonth(
                          (new Date().getMonth() + 1).toString()
                        );
                        setButton(null);
                        // fetchQuantity(itemID, selectedMonth, selectedYear, startDate, endDate)
                      } else {
                        setStartDate(value[0]);
                        setEndDate(value[1]);
                        setSelectedMonth(0);
                        setSelectedYear(0);
                        setButton(null);
                        //fetchQuantity(itemID, selectedMonth, selectedYear, startDate, endDate)
                      }
                    }}
                  />
                </div>

                {/* <select value={selectedYear}
                                        title="Select Year"
                                        onChange={(e) => setSelectedYear(e.target.value)}
                                        className="bg-white text-black border border-blueGray-600 rounded px-6 py-1 outline-none focus:outline-none md:w-32"
                                    >
                                        {years.map((year, index) => (
                                            <option key={index} value={year}>{year}</option>
                                        ))}
                                    </select> */}
                {/* <select value={selectedMonth}
                                        title="Select Month"
                                        onChange={(e) => setSelectedMonth(e.target.value)}
                                        className="bg-white text-black border border-blueGray-600 rounded ml-3 px-5 py-1 outline-none focus:outline-none md:w-32"
                                    >
                                        <option value="0">All</option>
                                        {months.map((month, index) => (
                                            // <option key={index} value={month}>{month}</option>
                                            <option key={index} value={month}>{getMonthName(month)}</option>
                                        ))}
                                    </select> */}
              </div>

              {/* This is tab code */}
              <div className="max-w-2xl mb-1 mx-auto">
                <div id="myTabContent">
                  <div
                    className={`bg-gray-50  rounded-lg dark:bg-gray-800`}
                    id="quantity-tracking"
                    role="tabpanel"
                    aria-labelledby="quantity-tracking-tab"
                  >
                    {/* here is the code of the tab */}
                    <div className="flex border-b border-gray-200 dark:border-gray-700">
                      {items
                        .sort((a, b) => a.tabOrder - b.tabOrder) // Sort items based on tabOrder
                        .map((item, index) => (
                          <button
                            key={index}
                            onClick={() => handleTabClick(index)}
                            style={
                              activeTab === index
                                ? {
                                    backgroundColor: item.color,
                                    fontWeight: "bold",
                                  }
                                : null
                            } // Apply background color dynamically
                            className={`px-4 py-2 ${
                              activeTab === index ? "text-white" : "text-black"
                            } hover:bg-blue-600 hover:text-white focus:outline-none border-b-2 border-transparent dark:hover:bg-gray-300 dark:hover:text-gray-800 ${
                              activeTab === index ? "" : "bg-gray-200"
                            }`}
                          >
                            {item.itemName}
                          </button>
                        ))}
                    </div>
                  </div>
                </div>
              </div>
              {/* Form Code */}
              <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                <form onSubmit={handleSubmit}>
                  <div className="flex justify-between flex-wrap md:flex-row w-full">
                    <DatePicker
                      selected={new Date(selectDate)}
                      onChange={(date) => setSelectedDate(date)}
                      className="form-control custom-height datepicker mr-4 custom-datepicker  mb-1  "
                      dateFormat="dd/MM/yyyy"
                      maxDate={currentDate} // Yahaan current date tak hi dates display ki gayi hain
                      style={{ zIndex: 9999 }}
                    />

                    <input
                      type="text"
                      id="quantity"
                      name="quantity"
                      className="form-control custom-height mr-4  custom-amount  mb-1  "
                      placeholder="Item Quantity"
                      maxLength={7}
                      ref={quantityInputRef}
                      value={formData.quantity}
                      onChange={handleChange}
                      onKeyPress={(e) => {
                        // Check if the pressed key is not a digit
                        if (e.target.value === "" && e.key === "0") {
                          e.preventDefault(); // Prevents insertion of '0' as the first character
                        } else if (!/^\d$/.test(e.key)) {
                          e.preventDefault(); // Prevents insertion of non-digit characters
                        }
                      }}
                    />

                    <input
                      type="text"
                      id="description"
                      name="description"
                      value={itemDescription}
                      onChange={handleDescriptionChange}
                      className="form-control custom-height mr-4 quantity-description  mb-1  "
                      placeholder="Description"
                      maxLength={150}
                    />
                    <button
                      className="text-white active:bg-lightBlue-600 text-xs font-bold uppercase mb-1  shadow hover:shadow-lg outline-none focus:outline-none ease-linear transition-all duration-150 quantity-button"
                      type="submit"
                      title={editing ? "Update Quantity" : "Add New Quantity"}
                    >
                      {editing ? "UPDATE" : "ADD"}{" "}
                      {/* Update button text based on editing state */}
                    </button>
                  </div>
                </form>
              </div>
            </>
          ) : (
            <tr>
              <td
                colSpan="8"
                className="text-center text-lg text-gray-900 mt-4"
              >
                <span style={{ textTransform: "uppercase" }}>
                  {" "}
                  Please add the item first{" "}
                </span>
                <button
                  onClick={NavigateAddItemPage}
                  className="bg-lightBlue-500 text-white ml-3 active:bg-lightBlue-600 text-xs font-bold uppercase px-4 py-1 mb-3 rounded shadow hover:shadow-lg outline-none focus:outline-none ease-linear transition-all duration-150"
                  type="button"
                >
                  Add Item
                </button>
              </td>
            </tr>
          )}

          {/* Table Code */}
          <div className="overflow-x-auto">
            <table className="w-full min-w-full ">
              <thead>
                <tr className="border-b bg-lightBlue-500 text-white ">
                  <th className="cell py-2 px-4 font-bold text-left">Date</th>
                  <th className="cell py-2 px-4 font-bold text-left">
                    Quantity
                  </th>
                  <th className="cell py-2 px-4 font-bold text-left">
                    Description
                  </th>
                  <th className="cell py-2 px-4 font-bold text-left">
                    Total({currency})
                  </th>
                  <th className="cell py-2 px-4 font-bold text-left">
                    Added By
                  </th>
                  <th
                    className="cell py-2 px-4 font-bold text-left"
                    style={{ float: "inline-end" }}
                  >
                    Actions
                  </th>
                </tr>
              </thead>
              <tbody>
                {quantitys && quantitys.length > 0 ? (
                  <>
                    {quantitys.map((quantity) => (
                      <tr
                        key={quantity.quantityTrackingID}
                        className="quantity-grid border-b"
                        style={{
                          backgroundColor:
                            quantity.checkPaid === 1 ? "#D5F5E3" : "	#FAD8DB ",
                        }}
                      >
                        <td className="cell py-1 px-4 text-left">
                          {new Date(quantity.date).toLocaleDateString("en-GB")}
                        </td>
                        <td className="cell py-1 px-4 text-left">
                          {quantity.quantity}
                        </td>
                        <td className="cell py-1 px-4 text-left">
                          {quantity.quantityDescription}
                        </td>
                        <td className="cell py-1 px-4 text-left">
                          <div
                            style={{ display: "flex", alignItems: "center" }}
                          >
                            <span>{quantity.total}</span>
                            {quantity.checkPaid === 1 && (
                              <img
                                src={require("assets/img/pngtree-img.png")}
                                style={{
                                  width: "40px",
                                  height: "35px",
                                  marginLeft: "10px",
                                }}
                                alt="Image"
                              />
                            )}
                          </div>
                        </td>

                        <td className="cell py-1 px-4 text-left">
                          {quantity.userName}
                        </td>
                        <td
                          className="cell py-1 px-4 flex items-center"
                          style={{ float: "inline-end" }}
                        >
                          {/* Edit Icon */}
                          {quantity.checkPaid == 1 ? (
                            <img
                              src={require("assets/img/Editicon.png")}
                              alt="Edit"
                              title="Edit"
                              className="mr-2 cursor-pointer"
                              style={{ width: "20px" }}
                            />
                          ) : (
                            <img
                              src={require("assets/img/Editicon.png")}
                              alt="Edit"
                              title="Edit"
                              className="mr-2 cursor-pointer"
                              style={{ width: "20px" }}
                              onClick={() => handleEditClick(quantity)}
                            />
                          )}

                          {/* Delete Icon */}
                          {quantity.checkPaid == 1 ? (
                            <img
                              src={require("assets/img/deleteicon.png")}
                              title="Delete"
                              alt="Delete"
                              className="cursor-pointer"
                              style={{ width: "20px" }}
                            />
                          ) : (
                            <img
                              src={require("assets/img/deleteicon.png")}
                              title="Delete"
                              alt="Delete"
                              className="cursor-pointer"
                              style={{ width: "20px" }}
                              onClick={() =>
                                deleteQuantity(quantity.quantityTrackingID)
                              }
                            />
                          )}
                        </td>
                      </tr>
                    ))}
                    <tr className="border-b">
                      <td className="cell py-1 px-4 text-left" colSpan="1"></td>
                      <td className="cell py-1 px-4 text-left" colSpan="2">
                        <span style={{ fontWeight: "bold" }}>
                          Total = {totalQuantity}
                        </span>
                      </td>
                      <td className="cell py-1 px-4 text-left" colSpan="3">
                        {/* Calculate the total price here */}
                        <span style={{ fontWeight: "bold" }}>
                          Total = {totalPrice}
                        </span>
                      </td>
                    </tr>
                  </>
                ) : (
                  <tr>
                    <td
                      colSpan="8"
                      className="text-center text-lg text-gray-900 mt-4"
                    >
                      No data found.
                    </td>
                  </tr>
                )}
              </tbody>
            </table>
          </div>
        </div>
      </div>
      {/* Add/Edit Modal */}
      <AddPayment
        isOpen={isOpen}
        onClose={closeModal}
        selectItem={selectItem}
        pandingPayment={pandingPayment}
        fetchQuantity={fetchQuantity}
        selectedYear={selectedYear}
        selectedMonth={selectedMonth}
      />
      <Footer />
    </>
  );
};

export default Quantitytracking;
